import React, { useState } from 'react';

import { Select, SpinnerOverlay, SubmissionButtons } from '@components/common';

import { useLinkAndVerifySites } from '@hooks/useLinkAndVerifySite';

import { isEmpty } from '@utils/common';

import { TSelectOption } from '@interfaces/components/componentTypes';

import styles from './LinkSiteToAssetForm.module.scss';

interface ILinkSiteToAssetFormProps {
	submitHandler: (siteDbId: string) => void;
	closeModal: () => void;
	isLinkAccess: boolean;
}

const LinkSiteToAssetForm = ({
	submitHandler,
	closeModal,
	isLinkAccess,
}: ILinkSiteToAssetFormProps) => {
	const [assetId, setAssetId] = useState<string>();

	const { rentedAssets, isLoadingRentedAssets } = useLinkAndVerifySites({ isLinkAccess });

	const onAssetChange = (option: TSelectOption<string>) => setAssetId(option?.value);

	const sitesOptions = !isEmpty(rentedAssets)
		? rentedAssets.map((asset) =>
			({ label: asset.assetId, value: asset.id, subText: asset.ownerName }))
		: [];

	const onSubmit = () => assetId && submitHandler(assetId);

	return (
		<div className={styles.linkAssetFormContainer}>
			{isLoadingRentedAssets && <SpinnerOverlay />}
			<span className={styles.infoText}>
				Select an Asset you have acquired or you own
			</span>
			<div className={styles.selectWrapper}>
				<Select
					handleChange={onAssetChange}
					isWithoutUseForms
					name='assetId'
					options={sitesOptions}
					placeholder='Choose Asset ID'
					required
					width='240px'
				/>
			</div>
			<SubmissionButtons
				disabledPositive={!assetId}
				negativeHandler={closeModal}
				positiveHandler={onSubmit}
				positiveLabel='Link'
			/>
		</div>
	);
};

export default LinkSiteToAssetForm;
